// src/pages/BookingDetailsPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BookingDetails from "../components/BookingDetails";
import { useParams } from 'react-router-dom';

const BookingDetailsPage = () => {
  const { bookingId } = useParams();
  console.log(bookingId); // Use this to fetch booking details from API or state
  return (
    <>
      <Header />
      <BookingDetails bookingId={bookingId} />
      <Footer />
    </>
  );
};

export default BookingDetailsPage;
